/** The fields a row can name a load by: a Ready-tab row, a load row, an invoice row, a write row or a readiness candidate. */
interface LoadKeyFields {
    load_id?: string | null
    load_number?: string | null
    load_numbers?: string[] | null
    invoice_id?: string | null
}

/**
 * The one key a row answers for, used by every place that matches a row to another (the turn's dedupe, the readiness groups, the
 * dimmed older rows): the load's id, else its number, else the invoice's id. An invoice of several loads has no single id, so its
 * first number stands for it. Undefined when the row names nothing.
 */
export const loadKeyOf = (row: LoadKeyFields): string | undefined => row.load_id ?? row.load_number ?? row.load_numbers?.[0] ?? row.invoice_id ?? undefined
